// Untrusted text (a crafted Google display name or email local part) reaches this
// file, and Excel/Sheets will execute a leading =/+/-/@ as a formula unless escaped.
const FORMULA_TRIGGER_RE = /^[=+\-@\t\r]/;

export function csvCell(value: string): string {
  const escaped = FORMULA_TRIGGER_RE.test(value) ? `'${value}` : value;
  return `"${escaped.replace(/"/g, '""')}"`;
}

export function toCsvRow(values: (string | number)[]): string {
  return values.map((v) => csvCell(String(v))).join(',');
}

export function buildCsv(rows: (string | number)[][], commentLines: string[] = []): string {
  const comments = commentLines.map((line) => csvCell(line));
  const body = rows.map(toCsvRow);
  return [...comments, ...body].join('\n');
}

export function downloadCsv(filename: string, content: string): void {
  const BOM = '﻿';
  const blob = new Blob([BOM + content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
